import { InsuranceConfirmationState, InsuranceState, InsurancePassengerState } from '@/models/www/store/InsuranceState';
import { stateStorage } from '@/services/storage.service';
import { defineStore } from 'pinia';

export const useInsuranceStore = defineStore('insurance', {
    state: () => {
        return {
            insuranceType: "",
            confirmations: [],
            passengers: [],
            extendInsurance: undefined
        } as InsuranceState
    },
    getters: {
        getConfirmations: (state) => {
            return state.confirmations;
        },
        getPassengers: (state) => {
            return state.passengers;
        },
        getType: (state) => {
            return state.insuranceType;
        },
        getExtendInsurance: (state) => {
            return state.extendInsurance;
        }
    },
    actions: {
        setType(insuranceType: string) {
            this.insuranceType = insuranceType;
        },
        setExtendInsurance(extend: boolean) {
            this.extendInsurance = extend;
        },
        setConfirmation(confirmation: InsuranceConfirmationState) {
            const index = this.confirmations.findIndex(x => x.type === confirmation.type);

            if (index > -1) {
                this.confirmations[index].value = confirmation.value
            }
            else {
                this.confirmations.push(confirmation);
            }
        },
        setConfirmations(confirmations: InsuranceConfirmationState[]) {
            this.confirmations = confirmations;
        },
        addPassenger(passenger: InsurancePassengerState) {
            this.passengers.push(passenger);
        },
        setPassengers(passengers: InsurancePassengerState[]) {
            this.passengers = passengers;
        },
        removePassenger(id: string) {
            this.passengers = this.passengers.filter(r => r.id !== id);
        },
    },
    persist: {
        enabled: true,
        strategies: [
            { storage: stateStorage },
        ],
    },
})